const OPEN_TURN_MAX_AGE_MS = 60 * 60 * 1000;

export interface OpenTurnArtifacts {
  type?: string;
  tool_name?: string;
  timestamp?: string;
}

export interface OpenTurnRow {
  turnType: "user" | "assistant";
  turnArtifacts?: OpenTurnArtifacts | null;
  completedAt?: string | null;
}

function isUnclosablePartialToolCall(row: OpenTurnRow): boolean {
  return row.turnArtifacts?.type === "tool_call" && !row.turnArtifacts.tool_name;
}

function isRunningRow(row: OpenTurnRow, now: number): boolean {
  if (row.completedAt != null || isUnclosablePartialToolCall(row)) return false;
  const startedAt = row.turnArtifacts?.timestamp;
  if (startedAt == null) return false;
  const ageMs = now - new Date(startedAt).getTime();
  return ageMs >= 0 && ageMs < OPEN_TURN_MAX_AGE_MS;
}

export function turnsSinceLastUserTurn<T extends OpenTurnRow>(rows: T[]): T[] {
  let lastUserIndex = -1;
  for (let rowIndex = 0; rowIndex < rows.length; rowIndex++) {
    if (rows[rowIndex].turnType === "user") lastUserIndex = rowIndex;
  }
  return rows.slice(lastUserIndex + 1);
}

export function hasOpenCurrentTurn(rows: OpenTurnRow[], now = Date.now()): boolean {
  return turnsSinceLastUserTurn(rows).some(row => isRunningRow(row, now));
}
